import PageScaffold from "../../components/PageScaffold";
import TextLabels from "./enums";
import PlaceOrderFormTest from "./PlaceOrderFormTest";

const Index = () => {
  return <PlaceOrderFormTest />;
};

export default Index;
